import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToolService {

  constructor(
  ) { }

  private isConsoleEnabled: boolean = false;

  showConsoleLog(...data: any[]): void {
    if (this.isConsoleEnabled) {
      console.log(...data);
    }
  }

  showConsoleError(...data: any[]): void {
    if (this.isConsoleEnabled) {
      console.error(...data);
    }
  }

  compressImage(file: File): Promise<File> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        const image = new Image();
        image.src = event.target.result;
        image.onload = () => {
          const canvas = document.createElement('canvas');
          const maxSize = 500;
          let width = image.width;
          let height = image.height;

          if (width > height) {
            if (width > maxSize) {
              height = Math.round((height *= maxSize / width));
              width = maxSize;
            }
          } else {
            if (height > maxSize) {
              width = Math.round((width *= maxSize / height));
              height = maxSize;
            }
          }

          canvas.width = width;
          canvas.height = height;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(image, 0, 0, width, height);

          canvas.toBlob(
            (blob) => {
              if (blob) {
                const compressedFile = new File([blob], file.name, {
                  type: file.type,
                  lastModified: Date.now()
                });
                resolve(compressedFile);
              } else {
                reject(new Error('Compression failed.'));
              }
            },
            file.type,
            0.7 // Adjust the compression quality here
          );
        };
      };
      reader.readAsDataURL(file);
    });
  }



}
